export enum ExperiencesTabEnum {
    WELLBEING_CONSULTATIONS = 'Wellbeing Consultations',
    SPA_SERVICES = 'Spa Services',
    ISLAND_ACTIVITIES = 'Island Activities',
    SALON_SERVICES = 'Salon Services',
    PORCUPINE_CREEK_TEMPORAL = 'Porcupine Creek MOE Category',
}
